import React from "react";
import { FormControl, FormLabel } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import { Input } from "@repo/ui";

export default function FormInput({
  label,
  rules,
  name,
  isRequired,
  info,
  disabled,
  readOnly,
  errors,
  control,
  inputProps,
  formControlProps,
  onBlur,
  onChange,
}) {
  return (
    <FormControl isRequired={Boolean(isRequired)} {...formControlProps}>
      <FormLabel>{label}</FormLabel>

      <Controller
        control={control}
        name={name}
        rules={rules || {}}
        render={({ field }) => (
          <>
            <Input
              {...inputProps}
              className={errors?.[name] ? "error-field" : ""}
              disabled={disabled}
              readOnly={readOnly}
              value={field.value || ""}
              onChange={(e) => {
                field.onChange(e.target.value);
                if (onChange) onChange(e.target.value);
              }}
              onBlur={(e) => {
                field.onBlur();
                if (onBlur) onBlur(e);
              }}
            />

            {info ? (
              <p className="text-sm text-gray-500 mt-1 italic">{info}</p>
            ) : null}

            {errors && errors[name] ? (
              <p className="text-sm text-red-500 mt-1">
                {errors[name].message || "Please Select Date!"}
              </p>
            ) : null}
          </>
        )}
      />
    </FormControl>
  );
}
